import { openDB } from "idb";

// Create/Open the database
const dbPromise = openDB("transfer-data", 1, {
  upgrade(db) {
    // Create an object store for our data
    db.createObjectStore("data", { keyPath: "id" });
  },
});

export const IndexedDBService = {
  // Get data from IndexedDB
  async getData(simulationId) {
    try {
      const db = await dbPromise;
      const data = await db.get("data", simulationId);
      
      
      return data;
    } catch (error) {
      
      
      return null;
    }
  },

  // Save data to IndexedDB
  async saveData(simulationId, data) {
    try {
      const db = await dbPromise;
      await db.put("data", {
        id: simulationId,
        data: data,
        timestamp: new Date().toISOString(),
      });
     
    } catch (error) {
     
    }
  },
};
